import { keys } from 'remeda'
import { InventoryStatus, Material, ModelStatus, ProductType, Stores } from '~/supabase/types'

export const storeLocationMap = {
  mandarin: 'Mandarin',
  wollem: 'Wollem',
} as const satisfies Record<Stores, string>

export const storeLocations = keys(storeLocationMap) as [Stores, ...Stores[]]

export const materialMap = {
  rose_gold: 'Rose gold',
  white_silver: 'Silver',
  rose_diamond: 'Rose Diamond',
  white_diamond: 'White Diamond',
  yellow_diamond: 'Yelow Diamond',
  moldavite_gemstone: 'Moldavite',
  garnet_gemstone: 'Garnet',
} as const satisfies Record<Material, string>

export const materials = keys(materialMap) as [Material, ...Material[]]

export const materialKeyMap = {
  rose_gold: 'go',
  white_silver: 'si',
  rose_diamond: 'di',
  white_diamond: 'di',
  yellow_diamond: 'di',
  moldavite_gemstone: 'mo',
  garnet_gemstone: 'ga',
} as const satisfies Record<Material, string>

export const materialSignKeyMap: Partial<Record<Material, string>> = {
  white_diamond: 'w',
  yellow_diamond: 'y',
}

export const productTypeKeyMap = {
  bracelet: 'br',
  earring: 'ea',
  necklace: 'ne',
  pendant: 'pe',
  ring: 'ri',
  gemstone: 'st',
  chain: 'ch',
} as const satisfies Record<ProductType, string>

export const productTypeMap = {
  bracelet: 'Bracelet',
  earring: 'Earring',
  necklace: 'Necklace',
  pendant: 'Pendant',
  ring: 'Ring',
  gemstone: 'Gemstone',
  chain: 'Chain',
} as const satisfies Record<ProductType, string>

export const productTypes = keys(productTypeMap) as [ProductType, ...ProductType[]]

export const modelStatusMap = {
  deprecated: { color: 'error', label: 'Deprecated' },
  incomplete: { color: 'warning', label: 'Incomplete' },
  ready: { color: 'info', label: 'Ready' },
  in_eshop: { color: 'success', label: 'In Eshop' },
} as const satisfies Record<ModelStatus, { color: string; label: string }>

export const modelStatuses = keys(modelStatusMap) as [ModelStatus, ...ModelStatus[]]

export const inventoryStatusMap = {
  unavailable: { color: 'warning', label: 'Unavailable' },
  available: { color: 'info', label: 'Available' },
  sold: { color: 'success', label: 'Sold' },
} as const satisfies Record<InventoryStatus, { color: string; label: string }>

export const inventoryStatuses = keys(inventoryStatusMap) as [InventoryStatus, ...InventoryStatus[]]

export const ringSizeMap = {
  46: '46',
  47: '47',
  48: '48',
  49: '49',
  50: '50',
  51: '51',
  52: '52',
  53: '53',
  54: '54',
  55: '55',
  56: '56',
  57: '57',
  58: '58',
  59: '59',
  60: '60',
  61: '61',
  62: '62',
  63: '63',
  64: '64',
  65: '65',
  66: '66',
  67: '67',
  68: '68',
} as const satisfies Record<string, string>

export const ringSizes = keys(ringSizeMap) as [string, ...string[]]
